import { Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const NoChartData = ({
  message = 'No data available for the selected time range',
  enableDarkTheme = false,
}: {
  message?: string;
  enableDarkTheme: boolean;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '18px',
          color: palette.textPrimary,
        }}
      >
        {message}
      </Typography>
    </>
  );
};

export default NoChartData;
